import {
  HttpErrorResponse,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CoreUtilsService } from './core-utils';

@Injectable({
  providedIn: 'root'
})
export class CoreHttpResponseInterceptor implements HttpInterceptor {
  private utils = inject(CoreUtilsService);

  /**
   * Http Interceptor to handle the HttpResponse and HttpErrorResponse
   * @param { HttpRequest } req
   * @param { HttpHandler } next
   * @returns HttpEvent
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(
        resp => {
          if (resp instanceof HttpResponse) {
            if (resp && resp.body && resp.body.payload && resp.body.signature) {
              const decryptedPayload = this.utils.decrypt(
                resp.body.payload,
                resp.body.signature
              );
              const parsedPayload = JSON.parse(decryptedPayload);
              const updatedResponse = resp.clone({ body: parsedPayload });
              return updatedResponse;
            }
          }
          return resp;
        },
        error => {
          return error;
        }
      ),
      catchError((error: HttpErrorResponse) => {
        // Client side error
        if (error.error instanceof ErrorEvent) {
          return throwError(error);
        } else {
          // server side error
          if (
            error &&
            error.error &&
            error.error.payload &&
            error.error.signature
          ) {
            const decryptedPayload = this.utils.decrypt(
              error.error.payload,
              error.error.signature
            );
            const parsedPayload = JSON.parse(decryptedPayload);
            const updatedErrorResponse = {
              ...error,
              error: parsedPayload
            };
            return throwError(updatedErrorResponse);
          }
        }
        return throwError(error);
      })
    );
  }
}
